import {
  getList,
  updateStar,
  deleteStar,
  visitingRecord,
  getSubjectTree,
  getAssetStatement,
  demandList,
} from '@/api/modules/home';

type State = {
  pageNum: number;
  pageSize: number;
  total: number;
  tableList: [];
  demandList:[];
  firstTreeList:[];
  checkList: [number | string, number | string, number | string, ]
  checkListStr: [number | string, number | string, number | string, ]
  visitTimeOrderBy: string,
  demmandEditShow: boolean,
  isCollect: boolean,
  isAuth: boolean,
  explainData: object,
  showdrawer: boolean,
  loading: boolean,
  rowitem: any,
};

const storeState: State = {
  pageNum: 1,
  pageSize: 10,
  total: 0,
  tableList: [], // 首页-列表
  demandList: [], // 首页-我的需求
  firstTreeList: [], // 主题第一级数据
  checkList: ['ALL', 'ALL', 'ALL'], // 主题点击
  checkListStr: ['', '', ''], // 主题点击
  visitTimeOrderBy: 'DESC', // 访问时间排序
  demmandEditShow: false, // 发起需求弹窗展示
  isCollect: false, // 我收藏的
  isAuth: true, // 有权限的
  explainData: {}, // 指标说明书
  showdrawer: false, // 指标说明书展示
  loading: true, // 首页-列表loading
  rowitem: null, // 选中的
};

const actions = {
  async getTableList(context: any, obj: any) {
    context.commit('setLoading', true);
    const { state } = context;
    const tempObj = {
      isCollect: state.isCollect, // 是否收藏 ture:收藏 false:全量
      isAuth: state.isAuth, // 是否有权限 true:有权限 false:无权限
      searchStr: obj.searchStr, // 查询关键词
      subjectLevel1: obj.subjectLevel1, // 一级主题
      subjectLevel2: obj.subjectLevel2, // 二级主题
      subjectLevel3: obj.subjectLevel3, // 三级主题
      pageNum: state.pageNum, // 当前页
      pageSize: state.pageSize, // 每页显示条数
      visitTimeOrderBy: state.visitTimeOrderBy,
    };
    try {
      const { data } = await getList(tempObj);
      const tableData = data.list;
      tableData.forEach((item:any) => {
        item.statementName = item.statementName || '-';
        item.personInCharge = item.personInCharge || '-';
        item.sourcedProduct = item.sourcedProduct || '-';
        item.belongProject = item.belongProject || '-';
        item.visitTimeDesc = item.visitTimeDesc || '-';
      });
      context.commit('setLoading', false);
      context.commit('setTableList', tableData);
      context.commit('setTotal', data.totalCount);
    } catch (error) {
      context.commit('setLoading', false);
    }
  },
  updateTableStar(context: any, obj: any) {
    const tempObj = {
      id: obj.id, // 主键id
      statementId: obj.statementId, // 报表关联Code
    };
    return new Promise((resolve, reject) => {
      updateStar(tempObj)
        .then(({ data }: any) => {
          resolve(data);
        }).catch(() => {
          reject();
        });
    });
  },
  deleteTableStar(context: any, obj: any) {
    return new Promise((resolve, reject) => {
      deleteStar(obj.id)
        .then(({ data }: any) => {
          resolve(data);
        }).catch(() => {
          reject();
        });
    });
  },
  async visitingRecord(context: any, obj: any) {
    const tempObj = {
      statementId: obj.statementId, // 报表Code
    };
    await visitingRecord(tempObj);
  },
  async getSubjectTreeList(context: any, obj: any) {
    const { data } = await getSubjectTree();
    const params = { data, obj };
    context.commit('setSubjectTree', params);
    context.commit('resetCheck', 0);
  },
  async getAssetStatement(context: any, assetStatementId: any) {
    const res = await getAssetStatement(assetStatementId);
    if (res.code === '200') {
      context.commit('setAssetStatement', {
        data: res.data,
        showFlag: true,
      });
    }
  },
  async getDemandList(context: any) {
    const { data } = await demandList();
    context.commit('setDemandList', data);
  },
  changeCheck({ commit }: any, { subjectId, subjectName, level }: any): void {
    commit('setCheck', {
      subjectId, subjectName, level,
    });
    commit('resetCheck', level);
  },
};

// mutations
const mutations = {
  setTableList(state: State, list: any): void {
    state.tableList = list;
  },
  setTotal(state: State, list: any): void {
    state.total = list;
  },
  setPageSize(state: State, pageSize: any): void {
    state.pageSize = pageSize;
  },
  setPageNum(state: State, pageNum: any): void {
    state.pageNum = pageNum;
  },
  setDemandList(state: State, list: any): void {
    state.demandList = list;
  },
  setSubjectTree(state: State, { data }: any): void {
    data[0].childList.unshift({
      subjectId: 'ALL',
      subjectName: '',
      iconName: 'icon-all',
      check: true,
      parentId: '',
      commonCodeLevel: '1',
      childList: [],
      statementList: [],
    });
    state.firstTreeList = data[0].childList;
    state.checkList[0] = 'ALL';
    state.checkListStr[0] = '';
  },
  // 接口200的时候展示
  setAssetStatement(state: State, obj: any) {
    state.showdrawer = obj.showFlag;
    state.explainData = obj.data;
  },
  // 指标说明书关闭的时候-更新值为false
  setAssetStatementShow(state: State, val: boolean) {
    state.showdrawer = val;
  },
  setCheck(state: any, { subjectId, subjectName, level }: any) {
    state.checkList[level] = subjectId;
    state.checkListStr[level] = subjectName;
  },
  resetCheck(state: any, level: number) {
    state.checkList.forEach((check: any, index: number) => {
      if (index > level) {
        state.checkList[index] = 'ALL';
        state.checkListStr[index] = '';
      }
    });
  },
  setVisitTimeOrder(state: any, visitTimeOrderBy: string) {
    state.visitTimeOrderBy = visitTimeOrderBy;
  },
  setDemmandEditShow(state: any, demmandEditShow: boolean) {
    state.demmandEditShow = demmandEditShow;
    if (state.demmandEditShow) {
      window.zhuge.track('发起新需求', {
        所在页面: '首页',
        所在入口: '首页报表咨询',
      });
    }
  },
  // 搜索项-我收藏的
  setIsCollect(state: any, isCollect: boolean) {
    state.isCollect = isCollect;
    window.zhuge.track(state.isCollect ? '勾选我收藏的' : '取消我收藏的', {
      所在页面: '首页',
    });
  },
  setIsAuth(state: any, isAuth: boolean) {
    state.isAuth = isAuth;
    window.zhuge.track(state.isAuth ? '勾选有权限的' : '取消有权限的', {
      所在页面: '首页',
    });
  },
  setLoading(state: any, loading: boolean) {
    state.loading = loading;
  },
  setrowitem(state: any, rowitem: any) {
    state.rowitem = rowitem;
  },
};

export default {
  namespaced: true,
  state: storeState,
  actions,
  mutations,
};
